import React from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {Card } from "@tremor/react";
import { ReallocateTenantPaymentForm } from '../Forms';
import {
    Row,
    Col
} from 'reactstrap';

import { formatDate } from '../../utils';
import {
    fetchOptions,
    showLoading,
    showFeatureComingSoon,
    fetchPayments,
    sendPaymentReceipt,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    deletePayments,
    showCustomMessage,
    fetchCurrency,
    fetchPropertiesUnitsTenants,
    fetchUser
 } from '../../redux/actions';

import dayjs from 'dayjs';
import { handleChangeAmount } from '../../components/AmountFilter/amountFilterFunctions';
import {
    IonButton, IonCheckbox,
    IonContent, IonHeader, IonIcon, IonPage,
    IonSearchbar, IonTitle, IonToolbar,
    IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent,
    IonModal, IonButtons,
    IonFab, IonFabButton, IonFabList, IonMenuButton, IonSelect,
    IonSelectOption, IonLoading, IonChip, IonLabel
} from '@ionic/react';
import AmountFilter from '../../components/AmountFilter/amountFilter';
import PaymentListItem from './PaymentListItem';
import PaymentForm from '../Forms/PaymentForm';
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import {
    add,
    cash,
    document,
    optionsOutline
} from 'ionicons/icons';
import AssignTenantForm from '../Forms/AssignPaymentToTenantForm';
import * as PermChecker from '../../utils/PermUtils';
import BankStatement from '../../components/BankStatement';
import { OCCUPANT_TYPE, colorTheme, NOTIFICATION_TYPES } from '../../utils/constants';
import { openNotificationPromptIfEligible, handleNotificationPromptAllow, handleNotificationPromptDeny } from '../../utils/notificationPrompt';
import notificationService from '../../services/notificationService';
import NotificationPermissionModal from '../../components/NotificationPermissionModal';


const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        payments: state.payments,
        paymentsOrder: state.paymentsOrder,
        paymentsSummary: state.paymentsSummary,
        options: state.options,
        user: state.user,
        currency: state.currency
    };
}

const mapDispatchToProps = {
    fetchPayments,
    fetchOptions,
    showLoading,
    showFeatureComingSoon,
    sendPaymentReceipt,
    deletePayments,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    showCustomMessage,
    fetchCurrency,
    fetchPropertiesUnitsTenants,
    fetchUser
};


const PAGE_HOME = "homepage";
const PAGE_PAYMENT_FORM = "paymentForm";
const PAGE_REALLOCATE_PAYMENT_FORM = "reallocatePaymentForm";
const PAGE_UPLOAD_BANK_STATEMENT = "uploadBankStatement";
const PAGE_FILTERS = "filters";
const PAGE_ASSIGN_TENANT = "assignTenant";
class Payments extends React.Component{
    constructor(props){
        super(props);

        const routerState = this.props.location.state || {};
        this.handleChangeAmount= handleChangeAmount.bind(this);
        this.handleFilterModalDismiss = this.handleFilterModalDismiss.bind(this);
        this.handleCloseAssignTenantModal = this.handleCloseAssignTenantModal.bind(this);
        this.handleClosePaymentForm = this.handleClosePaymentForm.bind(this);
        this.state = {
            startDate: null,
            endDate: null,
            properties: [],
            focusedDateInput: null,
            tenantDetails: null,
            payments:[],
            selected:[],
            paymentId: "", // used when assigning a payment to a tenant
            propertyId: "",
            unitId: "",
            tenantId: "",
            paymentType: "",
            showLoading: false,
            unassigned: routerState.unassignedPayments || false,
            filters:{
                status: [
                    {id: 1, value: "draft", isChecked: false},
                    {id: 2, value: "confirmed", isChecked: false}
                ],
                paymentSource: [
                    {id: 1, value: "mpesa", isChecked: false},
                    {id: 2, value: "copilot", isChecked: false},
                    {id: 3, value: "bank_statement", isChecked: false},
                    {id: 4, value: "manual", isChecked: false}
                ]
            },
            minAmount: "",
            maxAmount: "",
            searchText: "",
            page: PAGE_HOME,
            errors: {
                minAmount: "",
                maxAmount: ""
            },
            currentSelectedPayments: [],
            paymentsOffset: "",
            orderedPayments: [],
            userAllPerms: {},
            isLoadingMore: false,
            showNotificationPrompt: false,
            notificationContext: routerState.notificationContext || null
        };
    }

    async fetchInitialData(){
        await Promise.all([
            (
                async () => {
                    this.props.showLoading(true);
                    let params={
                        tenantIds:[], propertyIds:[], unitIds:[], startDate: "", endDate:"",
                        minAmount:0, maxAmount:0, status:this.getSelectedStatusFilters(),
                        paymentSources: this.getSelectedPaymentSources(),
                        unassigned:this.state.unassigned, offset:this.state.paymentsOffset || "",
                        source: "PAYMENTS_TAB"
                    }
                    let payloadResult = await this.props.fetchPayments(params);
                    if(payloadResult && payloadResult.offset){
                        let paymentsOffset = payloadResult.offset;
                        this.setState({
                            paymentsOffset
                        })
                    }
                }
            )(),
            (async () => {
                if (Object.keys(this.props.properties).length === 0) {
                    this.props.showLoading(true);
                    await this.props.fetchPropertiesUnitsTenants();
                }
              })(),
            (
                async () => {
                    if(_.isEmpty(this.props.options)){
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.currency)){
                        this.props.showLoading(true);
                        await this.props.fetchCurrency();
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.user)){
                        this.props.showLoading(true);
                        await this.props.fetchUser();
                    }
                }
            )()
        ]);
    }

    getPaymentsOrder(){
        let order = this.props.paymentsOrder;
        let orderedRecords = [];
        for(let id of order){
            if ((this.props.payments).hasOwnProperty(id)) {
                orderedRecords.push(this.props.payments[id]);
            }
        }
        return this.formatPayments(orderedRecords);
    }

    async componentDidMount() {
        this.setState({showLoading: true});
        await this.fetchInitialData();

        const monthParam = this.props.location.state?.month || "";
        const propertyParam = this.props.location.state?.propertyId || "";
        const startDate = monthParam ? dayjs().month(monthParam).date(1) : null;
        const hasAllPaymentPerm = PermChecker.checkUserHasPermission(PermChecker.PAYMENT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllMsgPerm = PermChecker.checkUserHasPermission(PermChecker.MESSAGE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const payments = this.getPaymentsOrder();
        this.setState({
            properties: Object.values(this.props.properties),
            payments,
            currentSelectedPayments: payments,
            startDate: startDate,
            propertyId: Object.values(this.props.properties).length === 1 ? Object.values(this.props.properties)[0].propertyId : propertyParam,
            userAllPerms: {message:hasAllMsgPerm, payment: hasAllPaymentPerm}
        }, () => {
            const unassignedFromState = this.props.location.state?.unassignedPayments === true;
            this.applyUrlParams({ unassigned: unassignedFromState });
        });
        this.setState({showLoading: false});
      }

    async componentDidUpdate(prevProps, prevState){
        if (this.props.payments !== prevProps.payments){
            this.setState((state) => {
                const payments = this.getPaymentsOrder();
                return {
                    payments,
                    currentSelectedPayments : payments
                }
            });
        }
        const unassignedFromState = this.props.location.state?.unassignedPayments === true;
        const prevUnassignedFromState = prevProps.location.state?.unassignedPayments === true;
        if (unassignedFromState !== prevUnassignedFromState) {
            this.setState({ unassigned: unassignedFromState });
        }
        const notificationContext = this.props.location.state?.notificationContext || null;
        const prevNotificationContext = prevProps.location.state?.notificationContext || null;
        if (notificationContext !== prevNotificationContext) {
            this.setState({ notificationContext });
        }

        const filtersChanged = (
            this.state.filters !== prevState.filters ||
            this.state.minAmount !== prevState.minAmount ||
            this.state.maxAmount !== prevState.maxAmount ||
            this.state.startDate !== prevState.startDate ||
            this.state.endDate !== prevState.endDate ||
            this.state.propertyId !== prevState.propertyId ||
            this.state.unitId !== prevState.unitId||
            this.state.tenantId !== prevState.tenantId||
            this.state.unassigned !== prevState.unassigned||
            this.state.paymentId !== prevState.paymentId
        );
        if (filtersChanged){
            this.filterPayments();
        }
        if (filtersChanged || this.state.searchText !== prevState.searchText) {
            this.updateUrlParams({
                propertyId: this.state.propertyId,
                unitId: this.state.unitId,
                tenantId: this.state.tenantId,
                startDate: this.state.startDate ? dayjs(this.state.startDate).format('YYYY-MM-DD') : '',
                endDate: this.state.endDate ? dayjs(this.state.endDate).format('YYYY-MM-DD') : '',
                minAmount: this.state.minAmount,
                maxAmount: this.state.maxAmount,
                status: this.getSelectedStatusFilters(),
                paymentSources: this.getSelectedPaymentSources(),
                unassigned: this.state.unassigned ? 'true' : '',
                searchText: this.state.searchText
            });
        }
    }

    formatPayments(payments){
        return payments.map(
            payment => ({
                formattedDate: payment.paymentDate || formatDate(payment.created),
                tenantName: payment,
                propertyUnitName: payment.tenant,
                action: payment,
                ...payment
            })
        )
    }

    async filterPayments(){
        let params = this.getFilterParams();
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchPayments(params);
        let paymentsOffset = this.state.paymentsOffset;
        if(payloadResult){
            paymentsOffset = payloadResult.offset;
        }

        this.setState((state) => {
            const payments = this.getPaymentsOrder();
            return {
                payments,
                paymentsOffset
            }
        });
    }

    getDefaultPropertyId(){
        const properties = Object.values(this.props.properties || {});
        return properties.length === 1 ? properties[0].propertyId : "";
    }

    handleClearFilters(){
        this.setState((prevState) => ({
            startDate: null,
            endDate: null,
            minAmount: "",
            maxAmount: "",
            propertyId: this.getDefaultPropertyId(),
            unitId: "",
            tenantId: "",
            unassigned: false,
            filters: {
                ...prevState.filters,
                status: prevState.filters.status.map((s) => ({ ...s, isChecked: false })),
                paymentSource: prevState.filters.paymentSource.map((s) => ({ ...s, isChecked: false }))
            }
        }));
    }

    renderActiveFilters(){
        const hasDateFilter = !!(this.state.startDate || this.state.endDate);
        const hasAmountFilter = !!(this.state.minAmount || this.state.maxAmount);
        const hasStatusFilter = this.getSelectedStatusFilters().length > 0;
        const hasSourceFilter = this.getSelectedPaymentSources().length > 0;
        const hasPropertyFilter = !!this.state.propertyId;
        const hasUnitFilter = !!this.state.unitId;
        const hasUnassigned = !!this.state.unassigned;
        const hasFilters = hasDateFilter || hasAmountFilter || hasStatusFilter || hasSourceFilter || hasPropertyFilter || hasUnitFilter || hasUnassigned;

        if (!hasFilters) return null;

        return (
            <div className="ion-padding-start ion-padding-end" style={{ marginBottom: '6px' }}>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                    {hasPropertyFilter && (
                        <IonChip>
                            <IonLabel>Property</IonLabel>
                        </IonChip>
                    )}
                    {hasUnitFilter && (
                        <IonChip>
                            <IonLabel>Unit</IonLabel>
                        </IonChip>
                    )}
                    {hasDateFilter && (
                        <IonChip>
                            <IonLabel>Date Range</IonLabel>
                        </IonChip>
                    )}
                    {hasAmountFilter && (
                        <IonChip>
                            <IonLabel>Amount</IonLabel>
                        </IonChip>
                    )}
                    {hasStatusFilter && (
                        <IonChip>
                            <IonLabel>Status</IonLabel>
                        </IonChip>
                    )}
                    {hasSourceFilter && (
                        <IonChip>
                            <IonLabel>Source</IonLabel>
                        </IonChip>
                    )}
                    {hasUnassigned && (
                        <IonChip>
                            <IonLabel>Unassigned</IonLabel>
                        </IonChip>
                    )}
                    <IonChip onClick={this.handleClearFilters.bind(this)}>
                        <IonLabel>Clear All</IonLabel>
                    </IonChip>
                </div>
            </div>
        );
    }

    getFilterParams(offset="", appendData=false){
        let tenantIds = [];
        let unitIds = [];
        let propertyIds = [];

        if (this.state.propertyId){
            propertyIds = [this.state.propertyId];
            if(this.state.unitId){
                propertyIds = [];
                unitIds = [this.state.unitId];
                if(this.state.tenantId){
                    unitIds = [];
                    tenantIds = [this.state.tenantId]
                }
            }
        }

        return {
            tenantIds:tenantIds,
            propertyIds:propertyIds,
            unitIds:unitIds,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            minAmount: this.state.minAmount === "-" || this.state.minAmount === "." ? 0 : (this.state.minAmount ? parseFloat(this.state.minAmount) : 0),
            maxAmount: this.state.maxAmount === "-" || this.state.maxAmount === "." ? 0 : (this.state.maxAmount ? parseFloat(this.state.maxAmount) : 0),
            status:this.getSelectedStatusFilters(),
            paymentSources: this.getSelectedPaymentSources(),
            unassigned: this.state.unassigned,
            searchText: this.state.searchText,
            source: "PAYMENTS_TAB",
            offset,
            appendData
        };

    }

    getSelectedStatusFilters(){
        let allStatuses = this.state.filters.status;
        let selectedStatuses = [];
        allStatuses.map((status) => {
            if(status.isChecked){
                selectedStatuses.push(status.value)
            }
        })
        return selectedStatuses
    }

    getSelectedPaymentSources(){
        let allSources = this.state.filters.paymentSource;
        let selectedSources = [];
        allSources.map((source) => {
            if(source.isChecked){
                selectedSources.push(source.value)
            }
        });
        return selectedSources;
    }

    getUrlParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            propertyId: searchParams.get('propertyId') || '',
            unitId: searchParams.get('unitId') || '',
            tenantId: searchParams.get('tenantId') || '',
            startDate: searchParams.get('startDate') || '',
            endDate: searchParams.get('endDate') || '',
            minAmount: searchParams.get('minAmount') || '',
            maxAmount: searchParams.get('maxAmount') || '',
            status: searchParams.get('status') ? searchParams.get('status').split(',') : [],
            paymentSources: searchParams.get('paymentSources') ? searchParams.get('paymentSources').split(',') : [],
            unassigned: searchParams.get('unassigned') || '',
            searchText: searchParams.get('searchText') || ''
        };
    }

    updateUrlParams(params) {
        const searchParams = new URLSearchParams(this.props.location.search);
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
                searchParams.delete(key);
            } else {
                const formatted = Array.isArray(value) ? value.join(',') : String(value);
                searchParams.set(key, formatted);
            }
        });
        const queryString = searchParams.toString();
        this.props.history.replace({
            pathname: this.props.location.pathname,
            search: queryString ? `?${queryString}` : '',
            state: this.props.location.state
        });
    }

    applyUrlParams(overrides = {}) {
        const params = this.getUrlParams();
        const hasStatus = params.status.length > 0;
        const hasSources = params.paymentSources.length > 0;
        const nextStatus = this.state.filters.status.map((s) => ({
            ...s,
            isChecked: hasStatus ? params.status.includes(s.value) : s.isChecked
        }));
        const nextSources = this.state.filters.paymentSource.map((s) => ({
            ...s,
            isChecked: hasSources ? params.paymentSources.includes(s.value) : s.isChecked
        }));
        const unassignedOverride = overrides.unassigned === true ? true : null;
        this.setState({
            propertyId: params.propertyId || this.state.propertyId,
            unitId: params.unitId || this.state.unitId,
            tenantId: params.tenantId || this.state.tenantId,
            startDate: params.startDate ? dayjs(params.startDate) : this.state.startDate,
            endDate: params.endDate ? dayjs(params.endDate) : this.state.endDate,
            minAmount: params.minAmount || this.state.minAmount,
            maxAmount: params.maxAmount || this.state.maxAmount,
            unassigned: unassignedOverride !== null ? unassignedOverride : (params.unassigned === 'true' ? true : this.state.unassigned),
            searchText: params.searchText || this.state.searchText,
            filters: {
                ...this.state.filters,
                status: nextStatus,
                paymentSource: nextSources
            }
        });
    }

    handleCheckChildElement(filterKey, value, checked){
        this.setState((prevState) => {
            const items = prevState.filters[filterKey].map((item) => {
                if (item.value === value) {
                    return { ...item, isChecked: checked };
                }
                return { ...item };
            });
            return {
                filters: {
                    ...prevState.filters,
                    [filterKey]: items
                }
            };
        });
    }

    handleChange(event){
        const target = event.target.name;
        if (target.name !== "unassigned"){
            event.preventDefault();
        }else{
            if (target.checked){
                this.setState({
                    propertyId: "",
                    unitId: ""
                });
            }
        }
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});
    }

    handleSelectEditPayment(paymentId, event){
        event.preventDefault();
        this.setState({
            paymentId: paymentId,
            tenantDetails: this.props.payments[paymentId].tenant,
            page: PAGE_PAYMENT_FORM
        });
    }


    handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId, unitId, tenantId } = prevState;
            if (propertyId != value){
                propertyId = value;
                unitId = "";
                tenantId = "";
            }
            return {
                propertyId, unitId, tenantId
            };
        });
    }

    handleSelectUnit(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId, unitId, tenantId } = prevState;
            if (unitId != value){
                unitId = value;
                tenantId = "";
            }
            return {
                unitId,
                tenantId,
                propertyId,
            };
        });
    }

    handleSelectTenant(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            return {
                tenantId: value
            };
        });
    }

    async handlePaymentAction(key, value) {
        if (key === 'edit') {
            this.setState({ paymentId: value, tenantDetails: this.props.payments[value].tenant, page: PAGE_PAYMENT_FORM });
            Mixpanel.track("Payments tab: quick actions edit payment");
        } else if (key === 'sendReceipt') {
            this.props.showLoading(true);
            this.props.sendPaymentReceipt({ paymentIds: [value] });
            Mixpanel.track("Payments tab: quick actions send receipt");
            await this.showNotificationPromptIfEligible();
        } else if (key === 'downloadReceipt') {
            this.props.showLoading(true);
            this.props.downloadInvoiceOrReceipt('receipt', value);
            await this.showNotificationPromptIfEligible();
        } else if (key === 'reallocate') {
            this.onClickReallocatePayment(value);
        } else if (key === 'delete') {
            if (window.confirm("Are you sure you want to delete this payment?")) {
                this.props.showLoading(true);
                const paymentIds = [value];
                await this.props.deletePayments(paymentIds);
                await this.showNotificationPromptIfEligible();
            }
        }
    }

    handleCloseAssignTenantModal(){
        this.setState({page: PAGE_HOME, paymentId: "" });
    }

    async showNotificationPromptIfEligible() {
        await openNotificationPromptIfEligible((open) => this.setState({ showNotificationPrompt: open }));
    }

    renderAssignTenantModal(){
        return (
            <IonModal isOpen={this.state.page === PAGE_ASSIGN_TENANT} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Assign Payment to {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseAssignTenantModal}>
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <AssignTenantForm
                    dataName={"tenants"}
                    paymentId={this.state.paymentId}
                    unassignedFilter={this.state.unassigned}/>
            </IonContent>
            </IonModal>);
    }

    renderReallocatePaymentForm(){
        return (
            <IonModal isOpen={this.state.page === PAGE_REALLOCATE_PAYMENT_FORM} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Re-allocate Payment</IonTitle>
                        <IonButtons slot="end">
                        <IonButton onClick={this.handleCloseAssignTenantModal}>
                            Close
                        </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <ReallocateTenantPaymentForm
                    dataName={"tenants"}
                    paymentId={this.state.paymentId}
                    unassignedFilter={this.state.unassigned}/>
                </IonContent>
            </IonModal>
        );
    }

    onClickAssignTenant(paymentId){
        Mixpanel.track("Payments tab: Assign payment to tenant button");
        const notificationContext = this.state.notificationContext;
        if (notificationContext?.notification_type === NOTIFICATION_TYPES.payment_summary) {
            Mixpanel.track("reminder: payment_summary primary_action", {
                notification_type: notificationContext.notification_type,
                action: "assign_payment",
                actionId: notificationContext.actionId || "unknown",
                source: notificationContext.source || "unknown"
            });
            this.setState({ notificationContext: null });
        } else if (notificationContext?.notification_type === NOTIFICATION_TYPES.unassigned_payment_summary) {
            Mixpanel.track("reminder: unassigned_payment primary_action", {
                notification_type: notificationContext.notification_type,
                action: "assign_payment",
                actionId: notificationContext.actionId || "unknown",
                source: notificationContext.source || "unknown"
            });
            this.setState({ notificationContext: null });
        }
        this.setState({paymentId, page: PAGE_ASSIGN_TENANT});
    }

    onClickReallocatePayment(value){
        Mixpanel.track("Payments tab: Reallocate payment to tenant button");
        let paymentId = value;
        this.setState({paymentId});
        this.setState({page: PAGE_REALLOCATE_PAYMENT_FORM});
    }

    fetchMorePayments = async () => {
        if (this.state.isLoadingMore) return;
        this.setState({ isLoadingMore: true });
        if (!this.state.paymentsOffset) return;
        const params = this.getFilterParams(this.state.paymentsOffset, true);
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchPayments(params);
        let paymentsOffset = this.state.paymentsOffset;
        if (payloadResult) {
            paymentsOffset = payloadResult.offset;
        }
        const payments = this.getPaymentsOrder();
        this.setState({
            payments,
            paymentsOffset,
            isLoadingMore: false
        });
        this.props.showLoading(false);
    }

    renderPaymentsTable(){
        return (
            <React.Fragment>
                <IonHeader className="ion-no-border">
                    <Row className='mr-0'>
                        <Col className='mr-0 pr-0 mx-md-4' xs={10} md={10}>
                            <IonSearchbar
                                onIonInput={(e) => {
                                    this.setState({ searchText: e.detail.value });
                                }}
                                onIonChange={async (e) => {
                                    this.setState({ searchText: e.detail.value });
                                    await this.filterPayments();

                                }}
                            />
                        </Col>
                        <Col className='mx-0 my-2 pt-1 rounded' xs={2} md={2} style={{width:'3.4375em', backgroundColor: colorTheme["primary"]["25"], color: colorTheme["primary"]["800"]}}>
                            <IonIcon onClick={ () => { this.setState({page: PAGE_FILTERS}) }}
                                size="large" aria-hidden="true" id='payment-filter-icon'
                            icon={optionsOutline}
                            />
                        </Col>
                    </Row>
                    {this.renderActiveFilters()}
                </IonHeader>
                <div>
                <Card style={{margin: 0, padding: 0}}>

                    <IonList id='ion-list-descriptions' style={{margin: 0, padding: 0}}>
                    {this.state.currentSelectedPayments.map((payment) => {
                        let tenantName = "";
                        let unitName = "";
                        let currency = "";
                        let propertyName = "";
                        if (payment.tenant){
                            tenantName = payment.tenant.firstName + " " + payment.tenant.lastName
                            unitName = !_.isEmpty(this.props.units)? this.props.units[payment.tenant.unitId].unitName: "";
                            currency = !_.isEmpty(this.props.currency)? this.props.currency.customerCurrency: "";
                            propertyName = !_.isEmpty(this.props.properties)? this.props.properties[payment.tenant.propertyId].propertyName: "";
                        }
                        return (<PaymentListItem
                            key={payment.paymentId}
                            paymentId={payment.paymentId}
                            tenantName={tenantName}
                            amount={payment.amount}
                            unitName={unitName}
                            propertyName={propertyName}
                            currency={currency}
                            paymentDate={payment.formattedDate}
                            payment={payment}
                            showDetails={false}                            
                            userAllPerms={this.state.userAllPerms}
                            options={this.props.options}
                            onClickAssignTenant={this.onClickAssignTenant.bind(this)}
                            handlePaymentAction={this.handlePaymentAction.bind(this)}
                        />
                        )
                    })}
                    </IonList>

                    <IonInfiniteScroll
                        disabled={!this.state.paymentsOffset}
                        threshold='100px'
                        onIonInfinite={async (ev) => {
                            if (this.state.isLoadingMore) {
                                ev.target.complete();
                                return;
                            }
                            this.setState({ isLoadingMore: true });
                            await this.fetchMorePayments();
                            this.setState({ isLoadingMore: false }, () => {
                                ev.target.complete();
                            });
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>

                    {this.state.paymentsOffset && (
                        <div className="ion-padding">
                            <IonButton
                                expand="block"
                                onClick={async () => {
                                    this.props.showLoading(true);
                                    await this.fetchMorePayments();
                                    this.props.showLoading(false);
                                }}
                            >
                                Load More Payments
                            </IonButton>
                        </div>
                    )}
                </Card>
                </div>

            </React.Fragment>
        )
    }

    handleDownloadCSV(event) {
        event.preventDefault();
        let transactionType = "payments";
        let propertyIds, unitIds, tenantIds;


        if (this.state.propertyId) {
            propertyIds = [this.state.propertyId];
            if (this.state.unitId) {
                propertyIds = [];
                unitIds = [this.state.unitId];
                if (this.state.tenantId) {
                    unitIds = [];
                    tenantIds = [this.state.tenantId]
                }
            }
        }

        let filters = {
            property_ids : propertyIds ? propertyIds : [],
            unit_ids : unitIds ? unitIds : [],
            tenant_ids : tenantIds ? tenantIds : [],
            start_date : this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : "",
            end_date : this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : "",
            status : this.getSelectedStatusFilters(),
            min_amount:this.state.minAmount ? parseFloat(this.state.minAmount) : 0,
            max_amount:this.state.maxAmount ? parseFloat(this.state.maxAmount) : 0,
            unassigned: this.state.unassigned,
            source: this.getSelectedPaymentSources()


        }
        this.props.showLoading(true)
        Mixpanel.track("Payments tab: download csv button");
        this.props.downloadTransactions(transactionType, filters);
    }

    handleSelectTransactionCategory(transactionType, event){
        event.preventDefault();
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value});
    }

    handleClosePaymentForm(){
        this.setState({page: PAGE_HOME, paymentId: "", tenantDetails: null });
    }


    renderPaymentForm(){
        return (
            <IonModal isOpen={this.state.page === PAGE_PAYMENT_FORM} onDidDismiss={this.handleClosePaymentForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Payment Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleClosePaymentForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <PaymentForm
                        tenantDetails={this.state.tenantDetails}
                        paymentId={this.state.paymentId}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderUploadBankStatement(){
        return (
            <IonModal isOpen={this.state.page === PAGE_UPLOAD_BANK_STATEMENT} onDidDismiss={this.handleClosePaymentForm}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Upload Bank Statement</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={this.handleClosePaymentForm}>Close</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <BankStatement
                    handleCloseModal={this.handleClosePaymentForm}
                 />
            </IonContent>
        </IonModal>
        );
    }

    handleOpenPage(page, event){
        this.setState({page});
    }

    renderBulkUploadModal(modalTarget){
        // return (<TransactionsForm modalTarget={modalTarget} dataName={"payments"}/>);
    }

    async handleBulkSendReceipts(){
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a payment.");
        }else{
            this.props.showLoading(true);
            await this.props.sendPaymentReceipt({paymentIds: this.state.selected});
            Mixpanel.track("Payments tab: Bulk actions send receipt");
        }
    }

    async handleBulkEmailReceipts(){
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a payment.");
        }else{
            this.props.showLoading(true);
            await this.props.sendPaymentReceipt({paymentIds: this.state.selected});
            Mixpanel.track("Payments tab: Bulk actions send receipt");
        }
    }

    async handleDelete(){
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a payment.");
        }else if(confirm("Are you sure you want to delete these payments?")){
            this.props.showLoading(true);
            const paymentIds=this.state.selected;
            await this.props.deletePayments(paymentIds);
            Mixpanel.track("Payments tab: Delete actions");
        }
    }

    renderHomePage() {
        return (
            <div>
                {this.renderPaymentsTable()}
            </div>
        );
      }

    async handleFilterModalDismiss(){
        this.setState({page: PAGE_HOME});
        await this.filterPayments();
    }

    renderFilters(){
        return (
            <IonModal isOpen={this.state.page === PAGE_FILTERS} onDidDismiss={this.handleFilterModalDismiss}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filters</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleFilterModalDismiss}
                            >Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <div className='d-flex justify-content-center'>
                    <IonList style={{maxWidth: '350px'}}>
                    <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <IonSelect
                            label="Property"
                            labelPlacement="stacked"
                            interface="popover"
                            value={this.state.propertyId}
                            onIonChange={this.handleSelectProperty.bind(this)}
                        >
                            <IonCustomPropertySelect propertiesArray={this.state.properties}/>
                        </IonSelect>
                    </IonItem>
                    <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <IonSelect
                            label="Unit"
                            labelPlacement="stacked"
                            interface="popover"
                            value={this.state.unitId}
                            onIonChange={this.handleSelectUnit.bind(this)}
                        >
                            <IonSelectOption key={""} value="">All Units</IonSelectOption>
                            {this.state.propertyId == ""?
                                <IonSelectOption>Please First Select a Property ...</IonSelectOption> :
                                _.map(Object.keys(this.props.properties[this.state.propertyId]["units"]), (unit) => (
                                    <IonSelectOption key={unit} value={unit}>
                                        {this.props.units[unit].unitName}
                                    </IonSelectOption>
                            ))}
                        </IonSelect>
                    </IonItem>
                    <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ fontWeight: 700, fontSize: '1rem' }}>Date Range</div>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                                <input
                                    type="date"
                                    id="paymentsStartDate"
                                    name="paymentsStartDate"
                                    value={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState({ startDate: value ? dayjs(value) : null });
                                    }}
                                    style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                />
                                <input
                                    type="date"
                                    id="paymentsEndDate"
                                    name="paymentsEndDate"
                                    value={this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : ''}
                                    min={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : undefined}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState({ endDate: value ? dayjs(value) : null });
                                    }}
                                    style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                />
                            </div>
                        </div>
                    </IonItem>

                    <div style={{ marginTop: '6px', marginBottom: '6px', width: '100%' }}>
                    <AmountFilter
                        minAmount={this.state.minAmount}
                        maxAmount={this.state.maxAmount}
                        handleChangeAmount={this.handleChangeAmount}
                        component={"payments"}
                    />
                    </div>

                    <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ fontWeight: 700, fontSize: '1rem' }}>Payment Status</div>
                            {this.state.filters.status.map((status) => (
                                <IonItem key={status.id + status.isChecked.toString()}>
                                    <IonCheckbox
                                        labelPlacement="end"
                                        checked={status.isChecked}
                                        onIonChange={(e) => this.handleCheckChildElement("status", status.value, e.detail.checked)}
                                    >
                                        {status.value}
                                    </IonCheckbox>
                                </IonItem>
                            ))}
                        </div>
                    </IonItem>

                    <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ fontWeight: 700, fontSize: '1rem' }}>Payment Source</div>
                            {this.state.filters.paymentSource.map((source) => (
                                <IonItem key={source.id + source.isChecked.toString()}>
                                    <IonCheckbox
                                        labelPlacement="end"
                                        checked={source.isChecked}
                                        onIonChange={(e) => this.handleCheckChildElement("paymentSource", source.value, e.detail.checked)}
                                    >
                                        {source.value.replace("_", " ")}
                                    </IonCheckbox>
                                </IonItem>
                            ))}
                        </div>
                    </IonItem>

                    <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '100%' }}>
                            <div style={{ fontWeight: 700, fontSize: '1rem' }}>Unassigned Payments</div>
                        </div>
                    </IonItem>
                    <IonItem>
                        <IonCheckbox
                            name="unassigned"
                            id="unassigned"
                            labelPlacement="end"
                            checked={this.state.unassigned}
                            onIonChange={async (e) => {
                                this.setState({unassigned: e.detail.checked});
                            }}
                        >
                            Show unassigned payments
                        </IonCheckbox>
                    </IonItem>
                </IonList>
                </div>
                </IonContent>
            </IonModal>
        )
    }

    render() {
        return (
          <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Payments</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonLoading className="custom-loading" isOpen={this.state.showLoading} message="Loading ..." />

                {this.state.page === PAGE_HOME && this.renderHomePage()}

                {/* render Modals */}
                {this.renderFilters()}
                {this.renderPaymentForm()}
                {this.renderReallocatePaymentForm()}
                {this.renderAssignTenantModal()}

                {this.renderBulkUploadModal()}
                {this.state.page === PAGE_UPLOAD_BANK_STATEMENT && this.renderUploadBankStatement()}

                <NotificationPermissionModal
                    isOpen={this.state.showNotificationPrompt}
                    header="Enable notifications?"
                    message="Turn on notifications so you can get daily and weekly payment summaries."
                    onAllow={async () => {
                        await handleNotificationPromptAllow((open) => this.setState({ showNotificationPrompt: open }), 'payments');
                    }}
                    onDeny={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'payments');
                    }}
                    onCancel={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'payments');
                    }}
                />

                {this.state.page == PAGE_HOME && <IonFab id='payment-page-ion-fab' className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                    <IonFabButton aria-label="Actions">
                        <IonIcon icon={add} />
                    </IonFabButton>
                    <IonFabList side="top">
                        {this.state.userAllPerms.payment &&(
                            <>
                        <IonFabButton
                            onClick={() => this.setState({page: PAGE_PAYMENT_FORM})}
                            data-desc="Add New Payment"
                        >
                            <IonIcon icon={cash} id='payment-page-form-ion-fab-icon'></IonIcon>
                        </IonFabButton>


                        <IonFabButton
                            onClick={() => this.setState({page: PAGE_UPLOAD_BANK_STATEMENT})}
                            data-desc="Upload Bank Statement">
                            <IonIcon icon={document} id='payment-page-bank-form-ion-fab-icon'></IonIcon>
                        </IonFabButton>
                        </>)}
                    </IonFabList>
                    </IonFab>}
            </IonContent>
          </IonPage>
        );
      }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Payments));